import CardActions from '@mui/material/CardActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GetVariable } from '../../api/variables-endpoint';
import SnackbarAlert from '../../components/Alerts';
import DeleteVariableButton from '../../components/variables/DeleteVariableButton';
import AcceptButton from '../../components/AcceptButton';
import VariableDetails from '../../components/variables/VariableDetails';
import useConfigStyles from '../../components/useConfigStyles';
import { getLinkToEditVariable } from '../../navigator/links';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Variable } from '../../types/variable';
import { defaultVariable } from '../../types/defaultValues';
import useOperationAuthorizationChecks from '../../hooks/useOperationAuthorizationChecks';
import { UserOperations } from '../../types/user';

function VariableDetailsPage(): JSX.Element {
  const { variableName } = useParams<{ variableName: string }>();
  const [variable, setVariable] = useState<Variable>(defaultVariable);
  const [fetched, setFetched] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [notify, toggleNotification] = useState(false);
  const classes = useConfigStyles();
  const navigate = useNavigate();
  const canEditVariable = useOperationAuthorizationChecks([UserOperations.VARIABLE_EDIT]);

  const fetchVariable = useCallback(async () => {
    if (variableName) {
      const response = await GetVariable(variableName);
      if (response.success && response.data) {
        setVariable(response.data);
      } else {
        setResponseMessage(response.message || '');
      }
      setFetched(response.success);
    }
  }, [variableName]);

  useEffect(() => {
    fetchVariable();
  }, [fetchVariable]);

  const DeleteButton = () => (
    <DeleteVariableButton
      variable={variable}
      className={classes.button}
      onDeleteFail={(message) => {
        setResponseMessage(message);
        toggleNotification(true);
      }}
    />
  );

  const handleCloseSnackbar = () => {
    toggleNotification(false);
  };

  const handleEditClick = () => {
    navigate(getLinkToEditVariable(variableName!));
  };

  return !fetched ? (
    <span>{responseMessage}</span>
  ) : (
    <>
      <Card>
        <CardContent>
          <VariableDetails variable={variable} editable={false} />
        </CardContent>
        <CardActions>
          <Grid container alignItems='center' justifyContent='center' direction='row' spacing={5}>
            <Grid item>
              {canEditVariable && <AcceptButton label='Edit Variable' className={classes.button} onClick={handleEditClick} />}
            </Grid>
            <Grid item>
              <DeleteButton />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <SnackbarAlert open={notify} message={responseMessage} handleClose={handleCloseSnackbar} />
    </>
  );
}

export default VariableDetailsPage;
